import $api from "@/frontend/shared/api/axios";

export async function submitApplicationForm(data: any) {
  const env = import.meta.env.VITE_ENV;
  const url = env === "production" ? "/application-form/deutsche-telekom" : "/application-form/mock-inc";
  const response = await $api.post(url, { ...data });
  return response.data.data as { signUpToken: string; signUpUrl: string };
}
